import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// ADMIN AUTH APIS
// Controller: Adminauthcon.php
// ================================

// 1) Admin Login
export async function adminLogin(email, password) {
  try {
    const fd = new FormData();
    fd.append("email", email);
    fd.append("password", password);

    const res = await axios.post(`${apiBaseUrl}adminauthcon/admin_login`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}
